import { map, Observable, of, tap } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasData } from '../models/canvas.model'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface SaveCanvasArgs extends CanvasArgs {
  /** Current diagram data to persist. */
  data?: CanvasData
}

export class SaveCanvasCommand extends CanvasBaseCommand<SaveCanvasArgs> {
  readonly id = 'save'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'save'
  override label = 'Save'
  override tooltip = 'Save (Ctrl+S)'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: SaveCanvasArgs): boolean {
    return !!args?.hasUnsavedChanges && !args?.isSaving
  }

  override checkArguments(args?: SaveCanvasArgs): boolean {
    return !!args?.canvasId
  }

  protected doExecute(args?: SaveCanvasArgs): Observable<boolean> {
    if (!args?.canvasId || !args.data) return of(false)

    return this.canvasService.update_canvas(args.canvasId, args.data).pipe(
      tap(res => this.emitResult({ success: res.success, data: args.data })),
      map(res => res.success),
    )
  }
}
